import React from "react";
import HomeBanner from "../components/HomeBanner";
import ServiceCards from "../components/ServiceCards";
import HomeCarousel from "../components/HomeCarousel";
import carouselImage1 from "../Images/We_are_welcoming.jpg";
import CarouselImage2 from "../Images/carousel_img2.jpg";
import ReasonItem from "../components/ReasonItem";
import SpecialistScroller from "../components/SpecialistScroller";
import TestimonialsSection from "../components/TestimonialSection";
import FaqAccordion from "../components/FaqAccordion";

const Home = () => {
  return (
    <>
      <div className="page-container">
        <HomeBanner />
        <ServiceCards count={6} />
        <HomeCarousel
          headingText="We’re Welcoming New Patients And Can’t Wait To Meet You."
          highlightText="Welcoming"
          description="We use only the best quality materials on the market in order to provide the best products to our patients, so don’t worry about anything and book yourself."
          image={carouselImage1}
          showContactInput="True"
        />
        <ReasonItem showAppointmentBtn={true} />
        <HomeCarousel
          headingText="Leave your worries at the door and enjoy a healthier, more precise smile"
          highlightText="Precise smile"
          description="We use only the best quality materials on the market in order to provide the best products to our patients, So don’t worry about anything and book yourself."
          image={CarouselImage2}
          showAppointmentBtn={true}
        />
        <SpecialistScroller />
        <TestimonialsSection />
        <FaqAccordion />
      </div>
    </>
  );
};

export default Home;
